import React, { useState, useEffect } from 'react';
import { TYPE_SUCCESS, TYPE_FAIL, INTERVAL } from "assets/constants/Constants";
import { CALENDER_ICON } from "assets/constants/Icons";
import Spinner from 'components/Spinner';
import ShowToast from 'components/ShowToast';
import { getMetaDataCall, updateQuotationMetadataCall } from "lib/axiosUtils";
import { Divider, Button, Typography } from '@mui/material';
import { Settings as SettingsIcon } from '@mui/icons-material';
import moment from 'moment';
import "../BOM/bom.css";

const QuotationSettingsPage = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [metadataId, setMetadataId] = useState(null);
  const [formData, setFormData] = useState({
    paymentTermTitle: "PAYMENT TERM:",
    paymentTerm: "",
    deliveryTimeTitle: "DELIVERY TIME",
    deliveryTime: "",
    shipViaTitle: "Ship Via:",
    shipVia: "",
    incotermsTitle: "Incoterms:",
    incoterms: "",
    otherTermsAndConditionsTitle: "Other Terms & Conditions:",
    otherTermsAndConditions: "",
    russiaBelarusClauseTitle: "- No-Russia and Belarus Clause:",
    russiaBelarusClause: "",
    bankDetailsTitle: "Bank details",
    bankAccountName: "",
    bankName: "",
    bankCurrency: "INR",
    bankBranch: "",
    bankAddress: "",
    bankIfsc: "",
    bankAccountNumber: "",
    bankSwift: "",
    bankPhone: "",
    eoeTitle: "E & OE",
    eoe: "",
    footerCompanyName: "",
    footerCorporateOfficeTitle: "Corporate Office:",
    footerCorporateOffice: "",
    footerTechnologyCentreTitle: "Blade Grinding & Measurement Technology Centre:",
    footerTechnologyCentre: "",
    footerCompanyDetails: "",
    signatureBestRegards: "Best regards",
    signatureCompanyName: "",
    signatureElectronicDocumentNote: "",
    signatureSignedText: "signed",
    signatureSignatoryName: "",
    signatureSignatoryPhone: ""
  });

  useEffect(() => {
    fetchMetadata();
  }, []);

  const arrayToString = (arr) => Array.isArray(arr) ? arr.join('\n') : (arr || '');

  const fetchMetadata = async () => {
    setIsLoading(true);
    const response = await getMetaDataCall({}, {});
    if (response && response.data && response.data.result && response.data.result.length > 0) {
      const metaObj = response.data.result[0];
      setMetadataId(metaObj._id);
      const qm = metaObj.meta_data?.quotationMetadata || {};

      setFormData({
        paymentTermTitle: qm.paymentTermTitle || "PAYMENT TERM:",
        paymentTerm: arrayToString(qm.paymentTerm),
        deliveryTimeTitle: qm.deliveryTimeTitle || "DELIVERY TIME",
        deliveryTime: arrayToString(qm.deliveryTime),
        shipViaTitle: qm.shipViaTitle || "Ship Via:",
        shipVia: arrayToString(qm.shipVia),
        incotermsTitle: qm.incotermsTitle || "Incoterms:",
        incoterms: arrayToString(qm.incoterms),
        otherTermsAndConditionsTitle: qm.otherTermsAndConditionsTitle || "Other Terms & Conditions:",
        otherTermsAndConditions: arrayToString(qm.otherTermsAndConditions),
        russiaBelarusClauseTitle: qm.russiaBelarusClauseTitle || "- No-Russia and Belarus Clause:",
        russiaBelarusClause: arrayToString(qm.russiaBelarusClause),
        bankDetailsTitle: qm.bankDetailsTitle || "Bank details",
        bankAccountName: qm.bankDetails?.accountName || "",
        bankName: qm.bankDetails?.bank || "",
        bankCurrency: qm.bankDetails?.currency || "INR",
        bankBranch: qm.bankDetails?.branch || "",
        bankAddress: arrayToString(qm.bankDetails?.address),
        bankIfsc: qm.bankDetails?.ifsc || "",
        bankAccountNumber: qm.bankDetails?.accountNumber || "",
        bankSwift: qm.bankDetails?.swift || "",
        bankPhone: qm.bankDetails?.phone || "",
        eoeTitle: qm.eoeTitle || "E & OE",
        eoe: arrayToString(qm.eoe),
        footerCompanyName: qm.footer?.companyName || "",
         footerCorporateOfficeTitle: qm.footer?.corporateOfficeTitle || "Corporate Office:",
        footerCorporateOffice: arrayToString(qm.footer?.corporateOffice),
         footerTechnologyCentreTitle: qm.footer?.technologyCentreTitle || "Blade Grinding & Measurement Technology Centre:",
        footerTechnologyCentre: arrayToString(qm.footer?.technologyCentre),
        footerCompanyDetails: arrayToString(qm.footer?.companyDetails),
        signatureBestRegards: qm.signature?.bestRegards || "Best regards",
        signatureCompanyName: qm.signature?.companyName || "",
        signatureElectronicDocumentNote: qm.signature?.electronicDocumentNote || "",
        signatureSignedText: qm.signature?.signedText || "signed",
        signatureSignatoryName: qm.signature?.signatoryName || "",
        signatureSignatoryPhone: qm.signature?.signatoryPhone || ""
      });
    }
    setIsLoading(false);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const stringToArray = (str) => {
    if (!str) return [];
    return str.split('\n').filter(s => s.trim() !== '');
  };

  const handleSave = async () => {
    if (!metadataId) {
      ShowToast('Metadata ID not found, unable to update.', TYPE_FAIL, INTERVAL, props, "");
      return;
    }

    setIsLoading(true);

    const quotationMetadata = {
      paymentTermTitle: formData.paymentTermTitle,
      paymentTerm: formData.paymentTerm,
      deliveryTimeTitle: formData.deliveryTimeTitle,
      deliveryTime: stringToArray(formData.deliveryTime),
      shipViaTitle: formData.shipViaTitle,
      shipVia: formData.shipVia,
      incotermsTitle: formData.incotermsTitle,
      incoterms: formData.incoterms,
      otherTermsAndConditionsTitle: formData.otherTermsAndConditionsTitle,
      otherTermsAndConditions: stringToArray(formData.otherTermsAndConditions),
      russiaBelarusClauseTitle: formData.russiaBelarusClauseTitle,
      russiaBelarusClause: stringToArray(formData.russiaBelarusClause),
      bankDetailsTitle: formData.bankDetailsTitle,
      bankDetails: {
        accountName: formData.bankAccountName,
        bank: formData.bankName,
        currency: formData.bankCurrency,
        branch: formData.bankBranch,
        address: stringToArray(formData.bankAddress),
        ifsc: formData.bankIfsc,
        accountNumber: formData.bankAccountNumber,
        swift: formData.bankSwift,
        phone: formData.bankPhone
      },
      eoeTitle: formData.eoeTitle,
      eoe: stringToArray(formData.eoe),
      footer: {
        companyName: formData.footerCompanyName,
        corporateOfficeTitle: formData.footerCorporateOfficeTitle,
        corporateOffice: stringToArray(formData.footerCorporateOffice),
        technologyCentreTitle: formData.footerTechnologyCentreTitle,
        technologyCentre: stringToArray(formData.footerTechnologyCentre),
        companyDetails: stringToArray(formData.footerCompanyDetails)
      },
      signature: {
        bestRegards: formData.signatureBestRegards,
        companyName: formData.signatureCompanyName,
        electronicDocumentNote: formData.signatureElectronicDocumentNote,
        signedText: formData.signatureSignedText,
        signatoryName: formData.signatureSignatoryName,
        signatoryPhone: formData.signatureSignatoryPhone
      }
    };

    const response = await updateQuotationMetadataCall({}, { _id: metadataId, quotationMetadata });

    if (response && response.status === 'SUCCESS') {
            ShowToast('Quotation Metadata updated successfully', TYPE_SUCCESS, INTERVAL, props, "");
      await fetchMetadata();
    } else {
            ShowToast('Failed to update Quotation Metadata', TYPE_FAIL, INTERVAL, props, "");
    }
    setIsLoading(false);
  };

  const renderFieldRow = ({
    label,
    children,
    required = false,
    colSpace = "col-md-6",
  }) => (
    <div className={`${colSpace} mb-3 d-flex flex-column`}>
      <label
        className="form-label d-block bom-label"
        style={{ marginBottom: "6px" }}
      >
        {label}
        {required && <span className="text-danger ms-1">*</span>}
      </label>

      {children}
    </div>
  );
  const renderTextField = (name, label, multiline = false) =>
    renderFieldRow({
      label,
      colSpace: multiline ? "col-md-12" : "col-md-6",
      children: multiline ? (
        <textarea
          className="form-control-customer bom-input quotation-textarea"
          rows="4"
          name={name}
          value={formData[name]}
          onChange={handleInputChange}
        />
      ) : (
        <input
          type="text"
          className="form-control-customer bom-input"
          name={name}
          value={formData[name]}
          onChange={handleInputChange}
        />
      ),
    });

  return (
    <div className="main-content bom-page">
      <div className="pagetitle row" style={{ color: 'black', paddingTop: 15, marginTop: "-25px" }}>
        <div className="col-md-10 sm_device" style={{ display: 'flex', alignItems: 'center' }}>
          <SettingsIcon aria-hidden="true" />
          <span style={{ marginLeft: '7px' }}>Quotation Settings</span>
        </div>
        <div className="col-md-2 sm_device" style={{ textAlign: 'right' }}>
                    <i className={`${CALENDER_ICON}`}></i> {moment().format('DD MMM YYYY')}
        </div>
      </div>
      <Divider sx={{ mb: 2, mt: 2 }} />

      {isLoading ? (
        <Spinner />
      ) : (
        <div
          className="bom-layout-card"
          style={{
            padding: "25px",
          }}
        >
          <div className="bom-sidebar-header">
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <SettingsIcon
                    style={{
                    marginRight: '8px',
                    color: '#2d3d42',
                    fontSize: '16px'
                }}
                />
                    <span className="bom-sidebar-title">
                        Update Quotation
                     </span>
            </div>
          </div>
          <div className="row">
                {renderTextField('paymentTermTitle', 'Payment Term Title')}
                {renderTextField('paymentTerm', 'Payment Term')}
                {renderTextField('deliveryTimeTitle', 'Delivery Time Title')}
                {renderTextField('deliveryTime', 'Delivery Time (Multiline)', true)}
                {renderTextField('shipViaTitle', 'Ship Via Title')}
                {renderTextField('shipVia', 'Ship Via')}
                {renderTextField('incotermsTitle', 'Incoterms Title')}
                {renderTextField('incoterms', 'Incoterms')}
                {renderTextField('otherTermsAndConditionsTitle', 'Other T&C Title')}
                {renderTextField('otherTermsAndConditions', 'Other T&C (Multiline)', true)}
                {renderTextField('russiaBelarusClauseTitle', 'Russia/Belarus Clause Title')}
                {renderTextField('russiaBelarusClause', 'Russia/Belarus Clause (Multiline)', true)}
                {renderTextField('eoeTitle', 'E&OE Title')}
                {renderTextField('eoe', 'E&OE (Multiline)', true)}
          </div>

          <div
            style={{
              borderBottom: "1px solid #e5e5e5",
              margin: "25px 0",
            }}
          />

          <div className="bom-sidebar-header">
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                margin: 0,
              }}
            >
              Bank Details
            </Typography>
          </div>

          <div className="row">
                {renderTextField('bankDetailsTitle', 'Bank Details Title')}
                {renderTextField('bankAccountName', 'Account Name')}
                {renderTextField('bankName', 'Bank Name')}
                {renderTextField('bankCurrency', 'Currency')}
                {renderTextField('bankBranch', 'Branch')}
                {renderTextField('bankIfsc', 'IFSC')}
                {renderTextField('bankAccountNumber', 'Account Number')}
                {renderTextField('bankSwift', 'SWIFT')}
                {renderTextField('bankPhone', 'Phone')}
                {renderTextField('bankAddress', 'Address (Multiline)', true)}
          </div>

          <div
            style={{
              borderBottom: "1px solid #e5e5e5",
              margin: "25px 0",
            }}
          />

          <div className="bom-sidebar-header">
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                margin: 0,
              }}
            >
              Footer Information
            </Typography>
          </div>

          <div className="row">
                {renderTextField('footerCompanyName', 'Company Name')}
                {renderTextField('footerCorporateOfficeTitle', 'Corporate Office Title')}
                {renderTextField('footerCorporateOffice', 'Corporate Office (Multiline)', true)}
                {renderTextField('footerTechnologyCentreTitle', 'Technology Centre Title')}
                {renderTextField('footerTechnologyCentre', 'Technology Centre (Multiline)', true)}
                {renderTextField('footerCompanyDetails', 'Company Details / Tax (Multiline)', true)}
          </div>

          <div
            style={{
              borderBottom: "1px solid #e5e5e5",
              margin: "25px 0",
            }}
          />

          <div className="bom-sidebar-header">
            <span className="bom-sidebar-title">Signature Information</span>
          </div>

          <div className="row">
                {renderTextField('signatureBestRegards', 'Best Regards Text')}
                {renderTextField('signatureCompanyName', 'Company Name')}
                {renderTextField('signatureElectronicDocumentNote', 'Electronic Document Note', true)}
                {renderTextField('signatureSignedText', 'Signed Text')}
                {renderTextField('signatureSignatoryName', 'Signatory Name')}
                {renderTextField('signatureSignatoryPhone', 'Signatory Phone')}
          </div>

          <div style={{ marginTop: 30, textAlign: "left" }}>
            <button
                className="brand-button"
                onClick={handleSave}
                style={{
                    minWidth: '220px',
                    whiteSpace: 'nowrap'
                }}
            >
                Save Quotation Settings
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default QuotationSettingsPage;
